import React, { useState } from "react";
import FileUpload from "../../Common/FileUpload";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverAssetsAction from "../../../store/actions/DriverAssets";
import * as UserActions from "../../../store/actions/User";
import Errors from "../../../constants/Errors.json";
import variables from "../../../constants/assets/variables";
import InformationBar from "../../Common/InformationBar";
import { BottomSectionModal } from "../../../constants/assets/containers";
import NoFooterModal from "../../Common/NoFooterModal";
import Button from "sushiweb/Button";

const BulkUploadDriverAssetsPickupModal = (props) => {
  const { handleClose, bulkUploadAssetsPickup, setStatus } = props;
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");

  const sample_download_url = `${
    process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace(
          variables.routeEndpoint,
          variables.sampleFileEndPoint
        )}/sample/sample_assets_pickup_bulk_upload.csv`
      : ""
  }`;

  const instructions = [
    "<p>Provide driver_id as FEXXXXX</p>",
    "<p>Provide asset_name as <b>(Bag/T Shirt/Helmet/All Weather Jacket/Raincoat).</b>It is case sensitive and also be careful with spaces.</p>",
    "<p>If driver has multiple different asset then add it to separate row.</p>",
    "<p>Provide issuance_type as <b>(pickup/delivery)</b></p>",
    "<p>For a driver, if they have multiple assets to issue, issuance_type should be either <b>(pickup/delivery)</b> for all entries</p>",
    "<p>status is mandatory if issuance_type is delivery. valid values:<b>(SHIPPED/RETURNED/COMPLETED/OPT_IN_DELIVERED)</b></p>",
    "<p>There should be no space in name of the file. For example, <b>bulk_upload_assets_pickup (1).csv</b> is not allowed.</p>",
    "<p>Please refrain from putting anything else in columns other than (FE_id, asset_name, quantity, size, issuance_type, status , amount_per_asset, reissuance, asset_flow), as it may effect the processing of the file and can result in failures.</p>",
    "<p>Provide the field value of 'reissuance' as <b>TRUE</b> for re issuance of asset to existing riders.</p>",
    "<p>For an asset, amount_per_asset field value should be cost per asset(1 quantity). Total cost will be derived from the combination of this and quantity automatically.</p>",
    "<p>For flow_type OPT_IN please update column asset_flow with val: OPT_IN, else leave empty.</p>",
    "<p>For marking asset delivered(OPT_IN_DELIVERED) for flow_type OPT_IN, following columns: quantity, size, amount_per_asset are not required.</p>",
    "<p>A single bulk upload can have only one asset_flow type.",
  ];

  const handleUpload = () => {
    const payload = { filename: activeFile.name.replace(".csv", "") };
    bulkUploadAssetsPickup(payload).then((res) => {
      if (res) {
        setCallback_key(res.callback_key);
        setPresign_url(res.file_upload_url);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  return (
    <NoFooterModal
      header
      heading="Bulk upload driver assets pickup/delivery"
      handleClose={handleClose}
      id="BulkUploadAssetsPickupDashboard"
      modalButtons={
        <BottomSectionModal className="mt-20">
          <Button
            disabled={activeFile == ""}
            onClick={handleUpload}
            className="sushi-btn"
          >
            Confirm
          </Button>
        </BottomSectionModal>
      }
    >
      <InformationBar
        instructions={instructions}
        sampleUrl={sample_download_url}
      />
      <FileUpload
        title={"CSV File"}
        uploadUrl="/driver-assets/bulk"
        callback_key={callback_key}
        presign_url={presign_url}
        handleClose={handleClose}
        keyName="callback_key"
        activeFile={activeFile}
        setActiveFile={setActiveFile}
      />
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    bulkUploadAssetsPickup: bindActionCreators(
      DriverAssetsAction.bulkUploadAssetsPickup,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkUploadDriverAssetsPickupModal);
